module.exports = __webpack_public_path__ + "vue_assets/img/badge_deios_silver.aee4df76.png";